import React from "react"
import { useDispatch } from 'react-redux';
import { setIsOpen } from '../Actions/Navigation.action';

export default function NavigationMobileButton() {
    const dispatch = useDispatch()

    const show = () => {
        dispatch(setIsOpen(true))
    }

    return <i className="fal fa-bars" onClick={show}></i>
}